import {httpRequest} from '../config/axios';
import {getAppliedFilters} from '../utils/helper';

export async function getRawData({pageIndex, pageSize, filters}) {
  const {dateQuery, filterQuery} = getAppliedFilters({filters});
  if (!(dateQuery.from && dateQuery.to)) return {rows: [], pageCount: 0};
  const response = await httpRequest.post('/get-raw-data', {
    date: dateQuery,
    filters: {
      ...filterQuery,
    },
    page: pageIndex + 1,
    sort: {
      field: 'timestamp',
      type: -1,
    },
    limit: pageSize,
  });

  return {
    rows: response?.data?.data?.data?.list || [],
    totalCount: response?.data?.data?.data?.totalCount || null,
  };
}

export async function checkMenuProcessing({
  channelStoreCode,
  channelGroupCode,
  channelCorrelationId,
  rebelCorrelationId,
  filters,
}) {
  const dateQuery = {from: null, to: null};
  const filterQuery = {};
  filters.forEach((filter) => {
    if (filter?.id === 'Date' && filter?.value) {
      const [from, to] = filter?.value || [];
      dateQuery.from = from;
      dateQuery.to = to;
    } else if (filter.id === 'Channel') {
      if (channelGroupCode) {
        filterQuery.channelGroupCode = [channelGroupCode];
      }
    } else if (filter?.isApplied) {
      filterQuery[filter?.key] = filter?.value;
    }
  });
  if (!(dateQuery.from && dateQuery.to)) return {rows: [], pageCount: 0};
  const response = await httpRequest.post('/check-processing', {
    date: dateQuery,
    filters: {
      ...filterQuery,
      channelStoreCode: [channelStoreCode],
      channelCorrelationId,
      rebelCorrelationId,
    },
    page: 1,
    sort: {
      field: 'timestamp',
      type: -1,
    },
    limit: -1,
  });
  return response;
}

export async function getOperationsReport({filters}) {
  const {dateQuery, filterQuery} = getAppliedFilters({filters});
  if (!(dateQuery.from && dateQuery.to)) return {data: {}};
  const response = await httpRequest.post('/operations/report', {
    date: dateQuery,
    filters: {
      ...filterQuery,
    },
  });
  return {
    data: response?.data?.data?.data || {},
  };
}

export async function getPerformanceReport({filters}) {
  const {dateQuery, filterQuery} = getAppliedFilters({filters});
  if (!(dateQuery.from && dateQuery.to)) return {data: {}};
  const response = await httpRequest.post('/operations/performance', {
    date: dateQuery,
    filters: {
      ...filterQuery,
    },
  });
  return {
    data: response?.data?.data?.data || {},
  };
}
